import QuotaApi from 'api/sellsyaccountmanager/subscription';
const ACCOUNT_LEVEL = Object.freeze({
    TRIAL: 'trial',
    GOLD: 'gold',
});

const store = {
    namespaced: true,
    state: {
        id: 0,
        name: '',
        email: '',
        accountLevel: '',
        countryCode: '',
        phoneFormat: '',
        phonecallProtocol: '',
        canal: '',
        pricingVersion: 0,
        plan: '',

        // Intl data
        hourformat: 0,
        timeformat: '',
        numformat: {},

        // Other
        mainAddress: {},
        companyInformationLocked: false,

        // Timetracking
        timetracking: {},
        setupLang: '',
        uiLang: '',
        hasVat: false,

        units: [],
        unitOnLoad: false,

        isSelfService: 'Y',
        hasLicenseManagement: false,

        // Quotas
        quotas: [],
        plugins: [],
    },
    getters: {
        corpName: (state) => {
            return state.name;
        },
        datePickerFormat: (state) => {
            if (state.timeformat == 'dmy') {
                return 'DD/MM/YYYY';
            }
            return 'MM/DD/YYYY';
        },
        momentFormat: (state) => {
            if (state.timeformat === 'dmy') {
                return 'DD/MM/YYYY';
            }
            return 'MM/DD/YYYY';
        },
        units: (state) => {
            return state.units;
        },
        corpId: (state) => state.id,
        getIsSelfService: (state) => state.isSelfService.toUpperCase() === 'Y',
        getQuotaAI: (state) => state.quotas.sellsy_ai,
        quotaAILimitReached(state) {
            return state.quotas.sellsy_ai?.limit <= state.quotas.sellsy_ai?.used;
        },
        getIsTrial: (state) => state.accountLevel === ACCOUNT_LEVEL.TRIAL,
        getCompanyInformationLocked: (state) => state.companyInformationLocked,
        getAccountLevel: (state) => state.accountLevel,
        getCountryCode: (state) => state.countryCode,
        getUILang: (state) => state.uiLang,
        getNumformat: (state) => state.numformat,
    },
    mutations: {
        setUnits(state, units) {
            state.units = units;
        },
        setUnitLoad(state, load) {
            state.unitOnLoad = load;
        },
        setQuotaAI(state, quota) {
            state.quotas.sellsy_ai = quota;
        },
        setCompanyInformationLocked(state, locked) {
            state.companyInformationLocked = locked;
        },
    },
    actions: {
        fetchQuotaAI: async ({ commit }) => {
            const {
                data: { sellsy_ai },
            } = await QuotaApi.getQuotasAndCredits();
            commit('setQuotaAI', sellsy_ai);
        },
        setCompanyInformationLocked({ commit }, locked) {
            commit('setCompanyInformationLocked', locked);
        },
    },
};

const factory = (corp = {}) => {
    return {
        ...store,
        state: {
            ...store.state,
            id: corp.id,
            name: corp.name,
            email: corp.email,
            accountLevel: corp.accountLevel,
            countryCode: corp.countryCode,
            phoneFormat: corp.phoneFormat,
            phonecallProtocol: corp.phonecallProtocol,
            canal: corp.canal,
            pricingVersion: corp.pricingVersion,
            plan: corp.plan,
            quotaAI: corp.quotaAI,

            // SAM
            customer: corp.customer,

            // Intl data
            hourformat: corp.hourformat,
            timeformat: corp.timeformat,
            numformat: corp.numformat,

            // Other
            mainAddress: corp.mainAddress,

            // Timetracking
            timetracking: corp.timetracking,
            setupLang: corp.setupLang,
            uiLang: corp.uiLang,
            hasVat: corp.hasVat,
            isSelfService: corp.isSelfService,

            hasLicenseManagement: corp.hasLicenseManagement,

            quotas: corp.quotas,

            plugins: corp.plugins,
            units: corp.units,
            defaultAddressCountry: corp.defaultAddressCountry,

            companyInformationLocked: corp.company_information_locked,
        },
    };
};

export { store as default, factory };
